// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2JKim","additionalInfo":"AgreementModal_additionalInfo__RwwFG"};